import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
  const words = ["Interiors Beyond Limitations", "Premium Plywood", "Designer Hardware", "Decorative Laminates", "Digital Locks", "Modular Kitchens", "Vernika Designs"];
  return (
    <section data-testid="marquee" className="border-y border-white/5 py-8 bg-[#080808]">
      <Marquee speed={40} gradient gradientColor="#080808" gradientWidth={120}>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-lux text-3xl md:text-5xl text-[#b8b8b8] px-8 tracking-wide italic">{w}</span>
            <span className="text-[#e7c15a] text-2xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
